var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"data-title":"安丘专技教育-注册"}}),_c('phone-login-layout',[_c('login-form-component',{attrs:{"type":"register"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }